import { Avatar, Tag } from '@ads/components-react';
import { useTranslation } from 'react-i18next';

export interface QuestionSectionProps {
  /** Enunciado da questão (pode conter HTML) */
  readonly label: string | null | undefined;
  /** Rótulo do subtipo dissertativo vindo de `GET /api/v1/exam/exam-item-sub-types` */
  readonly subtypeLabel: string | null | undefined;
  /** Nome do autor da questão */
  readonly author: string | null | undefined;
}

/**
 * Cabeçalho de conteúdo do modal: subtipo, enunciado e autor da questão.
 *
 * O subtipo aparece para todos os subtipos — inclusive Artigo de opinião e
 * Dissertação, que não têm material de referência para exibir abaixo.
 */
export function QuestionSection({ label, subtypeLabel, author }: QuestionSectionProps) {
  const { t } = useTranslation('examCorrection');

  if (!label && !subtypeLabel) return null;

  return (
    <section className="border-b-hairline border-ctx-layout-border px-lg py-xxs flex flex-col gap-xxs">
      {subtypeLabel && (
        <div className="flex">
          <Tag label={subtypeLabel} size="sm" status="highlight" custom={{ text: 'text-nowrap' }} />
        </div>
      )}

      {label && (
        <p
          dangerouslySetInnerHTML={{ __html: label }}
          className="font-bold text-ctx-content-title ts-paragraph-xs"
        ></p>
      )}

      <div className="flex flex-col gap-nano">
        <span className="text-ctx-content-placeholder ts-caption-xxs">
          {t('modal.fields.author')}
        </span>
        <div className="flex items-center gap-nano">
          <Avatar size="md" fallback={(author ?? 'A').charAt(0).toUpperCase()} />
          <span className="text-ctx-content-title ts-subtitle-xxs">
            {author ?? t('modal.unknownAuthor')}
          </span>
        </div>
      </div>
    </section>
  );
}
